import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  FiltroSeparador,
  BotonActualizar,
  KpiRow,
  DashCard,
  ChartBox,
  montarGraficas,
  graficaDona,
  graficaBarras,
  fmtNumero,
  pctDe,
} from "./dashboardUI";

function DashboardGastos() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  const BANCO_EFECTIVO = process.env.REACT_APP_BANCO_EFECTIVO;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);



  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");


  const [info, setInfo] = useState([]);
  const [graficasCategorias, setGraficasCategorias] = useState([]);
  const [graficasSubCategorias, setGraficasSubCategorias] = useState([]);
  const [graficasMeses, setGraficasMeses] = useState([]);
  const [valorGastado, setValorGastado] = useState(0);
  const [taref, setTaref] = useState(0);

  const [categorias, setCategorias] = useState([]);
  const [subCategorias, setSubCategorias] = useState([]);
  const [solicitantes, setSolicitantes] = useState([]);
  const [meses, setMeses] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [selectedSubCategoria, setSelectedSubCategoria] = useState("");
  const [selectedSolicitante, setSelectedSolicitante] = useState("");
  const [selectedMes, setSelectedMes] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}Gastos/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;

      setInfo(allDisponible)

      let unicosCol = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idCategoria === value.idCategoria)
      );
      setCategorias(unicosCol);

      let unicosSubcat = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idSubCategoria === value.idSubCategoria)
      );
      setSubCategorias(unicosSubcat);
      
      let unicosSoli = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idSolicitante === value.idSolicitante)
      );
      setSolicitantes(unicosSoli);

      let unicosMes = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.Mes === value.Mes)
      );
      setMeses(unicosMes);
    

      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });

},[])


function BuscaInfo(){
  setInfo([])
  setSelectedCategoria("")
  setSelectedSubCategoria("")
  setSelectedMes("")
  setCargando(true)
  axios
  .get(`${URL_DASHBOARDS}Gastos/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;

      setInfo(allDisponible)

      let unicosCol = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idCategoria === value.idCategoria)
      );
      setCategorias(unicosCol);


      let unicosSubcat = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idSubCategoria === value.idSubCategoria)
      );
      setSubCategorias(unicosSubcat);
      
      let unicosSoli = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idSolicitante === value.idSolicitante)
      );
      setSolicitantes(unicosSoli);

      let unicosMes = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.Mes === value.Mes)
      );
      setMeses(unicosMes);
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
}

  useMemo(() => {
      let temp = info

          if (selectedMes) {
            temp = temp.filter((e) =>
              e.Mes.includes(selectedMes)
            );
          }
          if (selectedCategoria) {
            temp = temp.filter((e) =>
              e.idCategoria.includes(selectedCategoria)
            );
          }
          
          if (selectedSubCategoria) {
            temp = temp.filter((e) =>
              e.idSubCategoria.includes(selectedSubCategoria)
            );
          }
          
          if (selectedSolicitante) {
            temp = temp.filter((e) =>
              e.idSolicitante.includes(selectedSolicitante)
            );
          }
    

        let agrupadoCategoria = temp.reduce(function (groups, item) {
          const val = item["idCategoria"];
          groups[val] = groups[val] || {
            idCategoria: item.idCategoria,
            total: 0,
          };
          groups[val].total += item.total;
          groups[val].categoria = item.categoria;
          groups[val].idCategoria = item.idCategoria;
          return groups;
        }, []);

        let otraCategoria = Object.values(agrupadoCategoria).sort((a, b) =>
          a.total < b.total ? 1 : -1
        );

        setGraficasCategorias(otraCategoria);

 
        let agrupadoSubCategoria = temp.reduce(function (groups, item) {
          const val = item["idSubCategoria"];
          groups[val] = groups[val] || {
            idSubCategoria: item.idSubCategoria,
            total: 0,
          };
          groups[val].total += item.total;
          groups[val].subCategoria = item.subCategoria;
          groups[val].idSubCategoria = item.idSubCategoria;
          return groups;
        }, []);

        let otraSubCategoria = Object.values(agrupadoSubCategoria).sort((a, b) =>
          a.total < b.total ? 1 : -1
        );

        setGraficasSubCategorias(otraSubCategoria);


        let agrupadoMes = temp.reduce(function (groups, item) {
          const val = item["Mes"];
          groups[val] = groups[val] || {
            Mes: item.Mes,
            total: 0,
          };
          groups[val].total += item.total;
          groups[val].Mes = item.Mes;
          return groups;
        }, []);

        let otraMes = Object.values(agrupadoMes)
        // .sort((a, b) =>
        //   a.total < b.total ? 1 : -1
        // );

        setGraficasMeses(otraMes);


        let TVal = temp.map((c) => parseFloat(c.total));
        let TV = TVal.reduce((t, total, index) => t + total, 0);
        setValorGastado(TV);

        let tar = temp.filter((e) =>e.idBanco == BANCO_EFECTIVO);
        let TarVal = tar.map((c) => parseFloat(c.total));
        let TarV = TarVal.reduce((t, total, index) => t + total, 0);
        setTaref(TarV)


  }, [info, selectedMes, selectedCategoria, selectedSubCategoria, selectedSolicitante]);


  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdiv", (root) => graficaDona(root, { data: graficasCategorias, valor: "total", categoria: "categoria", moneda: true })],
        ["chartdivSubCategoria", (root) => graficaDona(root, { data: graficasSubCategorias, valor: "total", categoria: "subCategoria", moneda: true })],
        ["chartdivMes", (root) => graficaBarras(root, {
          data: graficasMeses, categoria: "Mes", series: [{ valor: "total", nombre: "Gasto", color: "#f97316" }],
          moneda: true, exportar: true, archivo: "Gastos_Mensual",
        })],
      ]),
    [graficasCategorias, graficasMeses, graficasSubCategorias]
  );

  const kpis = [
    { label: "Gasto total", value: valorGastado, formato: "moneda", icon: "fas fa-hand-holding-usd", color: "#f97316" },
    { label: "Efectivo", value: taref, formato: "moneda", icon: "fas fa-money-bill-wave", color: "#10b981", pct: pctDe(taref, valorGastado), sub: `${fmtNumero(pctDe(taref, valorGastado), 1)}% del gasto` },
    { label: "Categorías", value: graficasCategorias.length, formato: "entero", icon: "fas fa-folder-open", color: "#3b82f6" },
    { label: "Subcategorías", value: graficasSubCategorias.length, formato: "entero", icon: "fas fa-stream", color: "#8b5cf6" },
  ];

  return (
    <>
      <Header />
      {/* {user.menu_total ? ( */}
      <DashPage
        icon="fas fa-hand-holding-usd"
        color="#f97316"
        bg="#fff7ed"
        title="Dashboard Gastos"
        subtitle="Gasto del período por mes, categoría y subcategoría"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Fecha inicio" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
              }}
            />
          </Filtro>
          <Filtro label="Fecha fin" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
              }}
            />
          </Filtro>
          <BotonActualizar onClick={BuscaInfo} cargando={cargando} />

          <FiltroSeparador />

          <Filtro label="Mes">
            <Input
              bsSize="sm"
              type="select"
              value={selectedMes}
              onChange={(e) => {
                setSelectedMes(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {meses
                // .sort((a, b) => (a.Mes > b.Mes ? 1 : -1))
                .map((a) => {
                  return <option key={a.Mes} value={a.Mes}>{a.Mes}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Categoría">
            <Input
              bsSize="sm"
              type="select"
              value={selectedCategoria}
              onChange={(e) => {
                setSelectedCategoria(e.target.value);
              }}
            >
              <option value="">Todas</option>
              {categorias
                .sort((a, b) => (a.categoria > b.categoria ? 1 : -1))
                .map((a) => {
                  return <option key={a.idCategoria} value={a.idCategoria}>{a.categoria}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Subcategoría">
            <Input
              bsSize="sm"
              type="select"
              value={selectedSubCategoria}
              onChange={(e) => {
                setSelectedSubCategoria(e.target.value);
              }}
            >
              <option value="">Todas</option>
              {subCategorias
                .sort((a, b) => (a.subCategoria > b.subCategoria ? 1 : -1))
                .map((a) => {
                  return <option key={a.idSubCategoria} value={a.idSubCategoria}>{a.subCategoria}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Solicitante">
            <Input
              bsSize="sm"
              type="select"
              value={selectedSolicitante}
              onChange={(e) => {
                setSelectedSolicitante(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {solicitantes
                .sort((a, b) => (a.solicitante > b.solicitante ? 1 : -1))
                .map((a) => {
                  return <option key={a.idSolicitante} value={a.idSolicitante}>{a.solicitante}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col md={12}>
            <DashCard icon="fas fa-chart-bar" color="#f97316" title="Gasto mensual" subtitle="Importe gastado por mes">
              <ChartBox id="chartdivMes" height={320} cargando={cargando} vacio={graficasMeses.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-folder-open" color="#3b82f6" title="Gasto por categoría" subtitle="Importe y % del total">
              <ChartBox id="chartdiv" height={320} cargando={cargando} vacio={graficasCategorias.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-stream" color="#8b5cf6" title="Gasto por subcategoría" subtitle="Importe y % del total">
              <ChartBox id="chartdivSubCategoria" height={320} cargando={cargando} vacio={graficasSubCategorias.length === 0} />
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/* ) : undefined}  */}
    </>
  );
}
export default DashboardGastos;
